/**
 This function takes an array and returns a sorted version, without modifying
 the input array. This is functionally identical to [].toSorted, but that isn't available
 in our TypeScript type definitions, yet.

 @see <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toSorted>
 **/
export function toSorted<T>(array: T[], sort?: (a: T, b: T) => number): T[] {
  return [...array].sort(sort);
}
